export function FeedSkeleton() {
  return (
    <div className="rounded-xl border bg-card overflow-hidden animate-pulse">
      <div className="aspect-video bg-muted" />
      <div className="p-4 space-y-3">
        <div className="flex items-center gap-2">
          <div className="h-5 w-20 rounded-full bg-muted" />
          <div className="h-4 w-16 rounded bg-muted ml-auto" />
        </div>
        <div className="h-5 w-3/4 rounded bg-muted" />
        <div className="space-y-1.5">
          <div className="h-3.5 w-full rounded bg-muted" />
          <div className="h-3.5 w-5/6 rounded bg-muted" />
        </div>
      </div>
    </div>
  )
}
